import confetti from 'canvas-confetti';

const DEFAULT_COUNT = 200;
const TOP_TIGHT_POS = {
  origin: { x: 1.1, y: 0.2 },
};

const fire = (particleRatio: number, opts?: confetti.Options) => {
  confetti({
    ...TOP_TIGHT_POS,
    ...opts,
    particleCount: Math.floor(DEFAULT_COUNT * particleRatio),
    angle: 160,
  });
};

export const topRightBoom = () => {
  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });
  fire(0.2, {
    spread: 60,
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};
